module.exports = __webpack_public_path__ + "img/ff03_alt.87c0c5e0.svg";